<template>
  <div class="base-footer">
    <div class="tab-wrap">
      <router-link v-for="(item,index) in menus" :key="index" tag="li" :to="item.path" :class="{'active':active(item.path)}">{{item.name}}</router-link>
    </div>
  </div>
</template>

<script>

export default {
  name: 'BaseFooter',
  data () {
    return {
      activeIndex: 1,
      menus: [
        { path: '/new', name: '设备控制' },
        { path: '/machineShop', name: '车间管理' },
        { path: '/baseMap', name: '地图位置' },
        { path: '/electricityStatistic', name: '电力统计' }
      ]
    }
  },
  watch: {},
  mounted () {},
  computed: {},
  methods: {
    active (path) {
      return this.$route.path === path
    }
  }

}
</script>
<style lang="scss">
.base-footer{
  position: fixed;
  bottom:0;
  width: 100%;
  height:48px;
  background:rgba(22,75,153,0.3);
  .tab-wrap{
    display: flex;
    li{
      float: left;
      width:25%;
      line-height: 48px;
      text-align: center;
      list-style: none;
      cursor: pointer;
      font-size: 20px;
      color:#BBD4E9;
    }
    .active{
      color: #fff;
      font-size : 20px;
      background:linear-gradient(180deg,rgba(78,174,255,1),rgba(0,84,255,1));
      box-shadow:0px -1px 0px 0px rgba(0,30,68,1), 0px 1px 0px 0px rgba(18,133,255,0.8);
    }

  }

}
</style>
